
export interface GetBankAccountTransactionListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetBankAccountTransactionListPagingAndFilterResponseData
}

export interface GetBankAccountTransactionListPagingAndFilterResponseData {
    items: GetBankAccountTransactionListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetBankAccountTransactionListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetBankAccountTransactionListPagingAndFilterResponseTotals {
    /** Döviz bazında gruplanmış metin: "1.250,00 TRY, 45,00 USD" */
    amount: string
    rowCount: number
}

export interface GetBankAccountTransactionListPagingAndFilterResponseItem {
    bankAccountTransactionId: string
    companyId: string
    bankAccountId: string
    transactionId: string
    transactionReferenceId: string
    debtOrReceivable: string
    debtOrReceivableText: string
    transactionDate: string
    transactionDateStr: string
    intId: number
    description: string
    receipt: string
    debtTaxNo: string
    receivableTaxNo: string
    iban: string
    relatedCompanyId: string
    relatedBankAccountId: any
    relatedCaseId: any
    bankName: string
    bankLogo: any
    currencyTypeName: string
    processTypeId: any
    bankId: string
    bankAccountName: string
    bankAccountIban: string
    tempTransactionReferenceId: any
    isMatch: boolean
    matchType: string
    relatedAccount: string
    balanceBeforeTransaction: number
    amount: number
    balanceAfterTransaction: number
    currency: number
    invoiceMatchAmount: any
    invoiceMatchDate: any
    invoiceTransactionMappings: any[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetBankAccountTransactionListPagingAndFilterResponseData: GetBankAccountTransactionListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}